import { Grid, Box, Typography } from "@material-ui/core";
import {
  WHITE,
  counterTypesPageSize,
  BLUE_PRIMARY,
  BLUE_COLOR,
  ERROR_COLOR,
  ORANGE_COLOR,
  GREEN_PRIMRY,
} from "../utils/const";
import TypeImage from "../assets/img/types.jpg";
import Loading from "../components/loading";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { convertNumbers } from "../utils/ConvertNumbers";
import { useSelector } from "react-redux";
import useCustomState from "../hooks/State";
import Paginator from "../components/paginator";
import { useHistory } from "react-router";
import { useMountAPI } from "../hooks/APICall";
import { Link } from "react-router-dom";
import moment from "jalali-moment";
import InfoIcon from "@material-ui/icons/Info";
import Call from "../service/API";
import { useEffect } from "react";

const CounterTypeReports = (props) => {
  const totalStatistics = useCustomState({});
  const totalStatisticsIsLoading = useCustomState(true);

  const typesIsLoading = useCustomState(true);
  const types = useCustomState([]);
  const allTypesIsLoading = useCustomState(true);
  const allTypes = useCustomState([]);
  const allItems = useCustomState(0); // for pagination
  const selectedPage = useCustomState(1); // for pagination

  const history = useHistory();

  const typeUtils = {
    page: selectedPage.value, // for pagination
    count: counterTypesPageSize, // for pagination
    typeName: "",
    typeDate: "",
    isLoading: typesIsLoading,
    history: history,
    allItems: allItems, // for pagination
    types: types,
  };

  const totalStatisticsUtils = {
    isLoading: totalStatisticsIsLoading,
    totalStatistics: totalStatistics,
    history: history,
  };

  useMountAPI(fetchCounterTypes, typeUtils);
  useMountAPI(fetchStatistics, totalStatisticsUtils);

  // for pagination
  const selectedPageChanged = (newPage) => {
    if (newPage !== selectedPage.value) {
      selectedPage.handleChange(newPage);
      typeUtils.page = newPage;
      typesIsLoading.handleChange(true);
      fetchCounterTypes(typeUtils);
    }
  };

  const renderCounterTypeStatisticsTable = () => {
    if (totalStatisticsIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <TableContainer
          component={Paper}
          style={{
            width: "400px",
            maxWidth: "400px",
            marginRight: "auto",
            marginLeft: "auto",
          }}
        >
          <Table sx={{ maxWidth: 700 }} aria-label="customized table">
            <TableBody>
              <TableRow>
                <TableCell>تعداد نوع کنتور</TableCell>
                <TableCell>
                  {convertNumbers(totalStatistics.value.allTypes)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>نوع کنتور با بیشترین کنتور</TableCell>
                <TableCell>
                  {convertNumbers(
                    totalStatistics.value.typesWithMaxCounters.names +
                      " (" +
                      totalStatistics.value.typesWithMaxCounters.counters +
                      ")"
                  )}
                </TableCell>
              </TableRow>
              {totalStatistics.value.categoryInfo.map((category, idx) => {
                return (
                  <TableRow key={idx}>
                    <TableCell>{"تعداد نوع کنتور " + category.name}</TableCell>
                    <TableCell>{convertNumbers(category.numTypes)}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  };

  const renderCounterTypeStatistics = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            marginTop: "48px",
            paddingBottom: "16px",
            marginBottom: "16px",
            borderBottom: "1px solid #333333",
          }}
        >
          <Box
            textAlign={"left"}
            style={{
              maxWidth: "400px",
              width: "400px",
              marginRight: "auto",
              marginLeft: "auto",
              marginBottom: "16px",
            }}
          >
            <Typography style={{ fontWeight: "bold" }}>آمار کلی</Typography>
          </Box>
          {renderCounterTypeStatisticsTable()}
        </Grid>
      </>
    );
  };

  const renderPaginator = () => {
    {
      /* 
            begin: for pagination
          */
    }
    return (
      <Grid item sx={12} sm={12} md={12} lg={12}>
        <Grid container>
          <Paginator
            selectedPage={selectedPage.value}
            items={allItems.value}
            pageSize={counterTypesPageSize}
            selectedPageChanged={selectedPageChanged}
          />
        </Grid>
      </Grid>
    );
    {
      /* end: for pagination */
    }
  };

  const renderCounterTypeDetailsTable = () => {
    if (typesIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "260px" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <TableContainer
          component={Paper}
          style={{
            marginRight: "auto",
            marginLeft: "auto",
          }}
        >
          <Table sx={{ maxWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell align={"center"}>#</TableCell>
                <TableCell align={"center"}>نوع کنتور</TableCell>
                <TableCell align={"center"}>دسته</TableCell>
                <TableCell align={"center"}>تاریخ ثبت</TableCell>
                <TableCell align={"center"}>تعداد پروژه</TableCell>
                <TableCell align={"center"}>تعداد کنتور</TableCell>
                <TableCell align={"center"}>جزئیات</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {types.value.map((type, idx) => {
                const categoryStyle = {
                  color: "#fff",
                  backgroundColor: "green",
                  fontSize: "12px",
                  borderRadius: "4px",
                  paddingRight: "6px",
                  paddingLeft: "6px",
                  marginRight: "8px",
                };
                if (type.category.includes("آب")) {
                  categoryStyle.backgroundColor = BLUE_COLOR;
                } else if (type.category.includes("برق")) {
                  categoryStyle.backgroundColor = ERROR_COLOR;
                } else {
                  categoryStyle.backgroundColor = ORANGE_COLOR;
                }
                const category = (
                  <span style={categoryStyle}>
                    {convertNumbers(type.category)}
                  </span>
                );
                return (
                  <TableRow>
                    <TableCell align={"center"}>
                      {convertNumbers(
                        (selectedPage.value - 1) * counterTypesPageSize +
                          idx +
                          1
                      )}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(type.name)}
                    </TableCell>
                    <TableCell align={"center"}>{category}</TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(
                        moment(type.date).locale("fa").format("YYYY/MM/DD")
                      )}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(type.projects)}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(type.counters)}
                    </TableCell>
                    <TableCell align={"center"}>
                      <Link to={"/admin/counter-types/" + type.id}>
                        <InfoIcon
                          style={{
                            color: BLUE_PRIMARY,
                            fontSize: "24px",
                            cursor: "pointer",
                          }}
                        />
                      </Link>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  };

  const renderCounterTypeDetails = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            marginTop: "24px",
            paddingBottom: "16px",
            marginBottom: "16px",
            borderBottom: "1px solid #333333",
          }}
        >
          <Box
            textAlign={"left"}
            style={{
              marginRight: "auto",
              marginLeft: "auto",
              marginBottom: "16px",
            }}
          >
            <Typography style={{ fontWeight: "bold" }}>
              جزئیات آمار نوع کنتورها
            </Typography>
          </Box>
          {renderCounterTypeDetailsTable()}
          {renderPaginator()}
        </Grid>
      </>
    );
  };

  return (
    <Grid
      container
      style={{
        marginTop: "64px",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingRight: "8px",
        paddingLeft: "8px",
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          backgroundColor: WHITE,
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "24px",
          paddingBottom: "24px",
          borderRadius: "8px",
          position: "relative",
        }}
      >
        <Box
          style={{
            maxWidth: "250px",
            // border: "1px solid red",
            marginRight: "auto",
            marginLeft: "auto",
            marginTop: "-60px",
            paddingRight: "36px",
            paddingLeft: "36px",
            paddingTop: "24px",
            paddingBottom: "24px",
            borderRadius: "12px",
            backgroundColor: GREEN_PRIMRY,
            color: WHITE,
            cursor: "pointer",
          }}
          textAlign={"center"}
        >
          <Typography style={{ fontWeight: "bold" }}>
            گزارش نوع کنتورها
          </Typography>
        </Box>
        <Grid container>
          {renderCounterTypeStatistics()}
          {/*{renderProjectsByCities()}*/}
          {renderCounterTypeDetails()}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CounterTypeReports;

const processCounterTypes = (counterTypes) => {
  const results = [];
  let data;
  counterTypes.map((counterType) => {
    data = {
      id: counterType.water_meter_type_id,
      name: counterType.water_meter_type_name,
      projects: counterType.All_project_with_this_type,
      counters: counterType.All_counter_with_this_type,
      category: counterType.water_meter_tag.water_meter_tag_name,
      date: counterType.water_meter_type_create_date,
      images: counterType.water_meter_type_files,
    };
    results.push(data);
  });
  return results;
};

const fetchCounterTypes = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const typeName = utils.typeName;
  const typeDate = utils.typeDate;
  const isLoading = utils.isLoading;
  const history = utils.history;
  const allItems = utils.allItems; // for pagination
  const types = utils.types;

  const data = {
    page: page,
    count: count,
    water_meter_type_name: typeName,
    water_meter_type_create_date: typeDate,
  };

  Call("POST", "WaterMeterTypes/admin/getAll", data)
    .then((response) => {
      // console.log("counterTypes", response);
      if (response.data.code == 200) {
        const ts = response.data.data.results;
        allItems.handleChange(response.data.data["All_type's"]);
        types.handleChange(processCounterTypes(ts));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
        if (data.code == 403) {
          history.push("/admin/login");
        }
      }
      isLoading.handleChange(false);
    });
};

const processStatistics = (statistics) => {
  let types = "";
  let numCounters = 0;
  statistics.types_with_max_counter.map((type, idx) => {
    if (idx === 0) {
      types += type.water_meter_type_name;
      numCounters = type.number_of_counter;
    } else {
      types += "-" + type.water_meter_type_name;
    }
  });
  const catInfo = [];
  statistics.tags_info.map((cat) => {
    const data = {
      name: cat.water_meter_tag_name,
      numTypes: cat.number_of_type,
    };
    catInfo.push(data);
  });
  const processedStatistics = {
    allTypes: statistics.all_counter_types,
    typesWithMaxCounters: {
      names: types,
      counters: numCounters,
    },
    categoryInfo: catInfo,
  };

  // console.log(processedStatistics);

  return processedStatistics;
};

const fetchStatistics = (utils) => {
  const isLoading = utils.isLoading;
  const totalStatistics = utils.totalStatistics;
  const history = utils.history;

  Call("POST", "WaterMeterTypes/admin/total/statistics", null)
    .then((response) => {
      // console.log("total statistics: ", response);
      if (response.data.code === 200) {
        totalStatistics.handleChange(processStatistics(response.data.data));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      // console.log(error);
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
        if (data.code === 403) {
          history.push("/admin/login");
        }
      }
      isLoading.handleChange(false);
    });
};
